import React from 'react'

import i18n from 'translations'

export const Modalities = [
  {
    name: i18n.t('modalities:name'),
    component: React.lazy(() => import('../../../modules/admin/general-parameters/modalities/ModalitiesList')),
    path: '/admin/general-parameters/modalities',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('modalities:createModalities'),
    component: React.lazy(() => import('../../../modules/admin/general-parameters/modalities/ModalitiesCreate')),
    path: '/admin/general-parameters/modalities/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('modalities:editModalities'),
    component: React.lazy(() => import('../../../modules/admin/general-parameters/modalities/ModalitiesEdit')),
    path: '/admin/general-parameters/modalities/edit/:modalityId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
